export const APA_DETERMINATION_TIME_SUBMISSION_REQUEST = 'APA_DETERMINATION_TIME_SUBMISSION_REQUEST';
export const APA_DETERMINATION_TIME_SUBMISSION_SUCCESS = 'APA_DETERMINATION_TIME_SUBMISSION_SUCCESS';
export const APA_DETERMINATION_TIME_SUBMISSION_FAIL    = 'APA_DETERMINATION_TIME_SUBMISSION_FAIL';

